"use client";

import { IMuxVideoPlayer } from "@/sanity/globals/VideoPlayer";
import { HLSVideoPlayer } from "@/components/ui/SanityVideoPlayer";
import { cn } from "@/lib/utils";

// Looping, muted Mux stream filling the page behind the confirmation copy
// (Figma 5269:17173). The thumbnail doubles as the poster; a 20% black scrim
// and a fade to black at the bottom sit on top so the white copy and the
// footer stay legible.
export default function BackdropVideo({ video, className }: { video?: IMuxVideoPlayer; className?: string }) {
  const playbackId = video?.muxVideo?.playbackId;
  if (!playbackId) return null;

  return (
    <div
      aria-hidden
      className={cn("pointer-events-none overflow-hidden bg-black", className)}>
      <HLSVideoPlayer
        source={video}
        autoPlay
        muted
        loop
        playsInline
        poster={video?.thumbnail?.src}
        className="absolute inset-0 h-full w-full object-cover"
      />
      {/* Scrim between the footage and the copy. */}
      <div className="absolute inset-0 bg-black/40" />
      <div className="bg-gradient- to-b absolute inset-x-0 top-0 h-1/3 from-black to-transparent lg:hidden" />
      <div className="absolute inset-0 bg-gradient-to-b from-transparent to-black" />
    </div>
  );
}
